import { render, staticRenderFns } from "./avaliacao-select-editor.vue?vue&type=template&id=0704a939"
import script from "./avaliacao-select-editor.vue?vue&type=script&lang=js"
export * from "./avaliacao-select-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports